import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { Social } from './../../models/social/social.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-social-list',
  templateUrl: './social-list.component.html'
})
export class SocialListComponent extends ListBase<Social> implements OnInit, OnDestroy {

  public url = 'socials';
  public routePrefix = 'social';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
